import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Firebase configuration
// You'll need to replace these with your actual Firebase config values
const firebaseConfig = {
    apiKey: "AIzaSyBuX5iwIZXNxFC8yPC7ZXAb5NpgJlGQalM",
    authDomain: "barnbills-landing.firebaseapp.com",
    projectId: "barnbills-landing",
    storageBucket: "barnbills-landing.firebasestorage.app",
    messagingSenderId: "793767064644",
    appId: "1:793767064644:web:a00bffccbba1c7cbad3811",
    measurementId: "G-RX77ZPFDV6"
  };
    
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Collection references
export const launchUpdatesCollection = collection(db, 'launch-updates');
export const contactMessagesCollection = collection(db, 'contact-messages');

// TypeScript interfaces
export interface LaunchUpdate {
  email: string;
  timestamp: any;
}

export interface ContactMessage {
  name: string;
  email: string;
  farmType: string;
  subject: string;
  message: string;
  timestamp: any;
}

// Helper functions
export const addLaunchUpdate = async (email: string) => {
  try {
    const docRef = await addDoc(launchUpdatesCollection, {
      email,
      timestamp: serverTimestamp()
    });
    console.log('Launch update added with ID: ', docRef.id);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error adding launch update: ', error);
    return { success: false, error };
  }
};

export const addContactMessage = async (messageData: Omit<ContactMessage, 'timestamp'>) => {
  try {
    const docRef = await addDoc(contactMessagesCollection, {
      ...messageData,
      timestamp: serverTimestamp()
    });
    console.log('Contact message added with ID: ', docRef.id);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error adding contact message: ', error);
    return { success: false, error };
  }
}; 